import React from "react";

export const SocketContext = React.createContext({});

export const useWebsocket = () => React.useContext(SocketContext);